import { actions } from "@app/utils";
import { createApiClient } from "@app/utils/apiClient";

export const videosClient = createApiClient(
  actions["exd-storyteller-ai/ffmpeg"],
);

export const mergeVideos = async (
  { videoUrls, timestamps, s3Path },
  options = {},
) => {
  const response = await videosClient.post(
    "/merge",
    {
      videoUrls,
      timestamps,
      s3Path,
    },
    options,
  );

  if (!response.ok) {
    throw new Error("Failed to merge videos", { cause: response });
  }

  return response.data;
};
